import DmpConnectJSCnamManagerAdapter from "./dmpconnect-js/cnam-manager-adapter";
export let DmpAdapterName = /*#__PURE__*/function (DmpAdapterName) {
  DmpAdapterName["DMPConnectJsLocal"] = "dmpconnect_js";
  DmpAdapterName["DMPConnectJsOlaqin"] = "dmpconnect_js_olaqin";
  return DmpAdapterName;
}({});
export default class CnamManagerFactory {
  static getCnamManagerAdapter(medic, store, fetcher, accessToken, featuresService, requestManager) {
    switch (medic.dmpAdapterName) {
      case DmpAdapterName.DMPConnectJsLocal:
      case DmpAdapterName.DMPConnectJsOlaqin:
      default:
        return new DmpConnectJSCnamManagerAdapter(medic, store, accessToken, fetcher, requestManager, featuresService);
    }
  }
}